// src/store.js
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        // Add reducers here
    },
});

export default store;
